/**
 * @purpose: mengelola form customer price entry termasuk CRUD, generate pricing, dan validation.
 * @called_by: views/app_finance/customer_price.html.
 * @deps: AngularJS app, urlServices, modalService, toaster, ui-grid.
 * @public: customerPriceCtrl.
 * @side_effects: memuat pricing data, menyimpan/update/delete pricing, generate dari base price, validasi weight progression.
 */
app.controller('customerPriceCtrl', ['$rootScope', '$scope', '$filter', 'urlServices', 'modalService', 'modalFactory', 'toaster',
    function($rootScope, $scope, $filter, urlServices, modalService, modalFactory, toaster) {

    // Initialize data models
    $scope.data = {
        IsFlat: false,
        IsConsign: false,
        Limit: 0,
        Limit0: 0,
        Limit10: 0,
        Limit11: 0,
        Limit20: 0,
        Limit21: 0,
        Limit30: 0,
        Limit31: 0,
        Limit40: 0,
        Limit41: 0,
        Limit50: 0,
        Limit51: 0,
        Price1: 0,
        Price2: 0,
        Price3: 0,
        Price4: 0,
        Price5: 0,
        Price6: 0,
        LeadTime: 0,
        Internalrate: 0,
        Discount: 0,
        DiscountRate: 0,
        Minimum: 0,
        PublishRate: 0,
        PublishCode: ''
    };

    $scope.generateData = {
        BasePriceCode: '',
        DiscountPercent: 0
    };

    $scope.customerName = '';
    $scope.selectedNomor = null;
    $scope.isSaving = false;
    $scope.isGenerating = false;
    $scope.filterPriceCode = '';
    $scope.filterDestination = '';
    $scope.keepCustomer = false;
    $scope.cityLookupFor = null; // 'origin' | 'destination'
    $scope.showCheckPrice = false; // Toggle for Check Price view

    // Lookup data
    $scope.customerList = [];
    $scope.cityList = [];
    $scope.uomList = [];
    $scope.serviceList = [];
    $scope.modTransList = [];
    $scope.priceCodeList = [];
    $scope.consignSiteList = [];

    // Grid configuration - matches VB6 grid display
    $scope.gridOptions = {
        enableSorting: true,
        enableFiltering: false,
        enableRowSelection: true,
        enableRowHeaderSelection: false,
        multiSelect: false,
        enablePaginationControls: true,
        paginationPageSizes: [25, 50, 100],
        paginationPageSize: 25,
        columnDefs: [
            { field: 'Nomor', displayName: 'ID', width: 80, visible: false },
            { field: 'PriceCode', displayName: 'Code', width: 80 },
            { field: 'OriginCode', displayName: 'Org_Code', width: 80 },
            { field: 'OriginName', displayName: 'Org', width: 150 },
            { field: 'DestinationCode', displayName: 'Dest_Code', width: 80 },
            { field: 'DestinationName', displayName: 'Dest', width: 150 },
            { field: 'UOM', displayName: 'UOM', width: 50 },
            { field: 'Service', displayName: 'Service', width: 60 },
            { field: 'ModTrans', displayName: 'ModTrans', width: 70 },
            { field: 'Price1', displayName: 'Price1', width: 80, cellFilter: 'number:0', cellClass: 'text-right' },
            { field: 'Price2', displayName: 'Price2', width: 80, cellFilter: 'number:0', cellClass: 'text-right' },
            { field: 'Price3', displayName: 'Price3', width: 80, cellFilter: 'number:0', cellClass: 'text-right' },
            { field: 'Price4', displayName: 'Price4', width: 80, cellFilter: 'number:0', cellClass: 'text-right' },
            { field: 'Price5', displayName: 'Price5', width: 80, cellFilter: 'number:0', cellClass: 'text-right' },
            { field: 'Price6', displayName: 'Price6', width: 80, cellFilter: 'number:0', cellClass: 'text-right' },
            { field: 'LeadTime', displayName: 'Lead Time', width: 55, cellClass: 'text-center' },
            { field: 'Limit', displayName: 'Limit', width: 70, cellFilter: 'number:2', cellClass: 'text-right' },
            { field: 'Limit0', displayName: 'Limit0', width: 70, cellFilter: 'number:2', cellClass: 'text-right' },
            { field: 'Limit10', displayName: 'Limit10', width: 70, cellFilter: 'number:2', cellClass: 'text-right' },
            { field: 'Limit11', displayName: 'Limit11', width: 70, cellFilter: 'number:2', cellClass: 'text-right' },
            { field: 'Limit20', displayName: 'Limit20', width: 70, cellFilter: 'number:2', cellClass: 'text-right' },
            { field: 'Limit21', displayName: 'Limit21', width: 70, cellFilter: 'number:2', cellClass: 'text-right' },
            { field: 'Limit30', displayName: 'Limit30', width: 70, cellFilter: 'number:2', cellClass: 'text-right' },
            { field: 'Limit31', displayName: 'Limit31', width: 70, cellFilter: 'number:2', cellClass: 'text-right' },
            { field: 'Limit40', displayName: 'Limit40', width: 70, cellFilter: 'number:2', cellClass: 'text-right' },
            { field: 'Limit41', displayName: 'Limit41', width: 70, cellFilter: 'number:2', cellClass: 'text-right' },
            { field: 'Limit50', displayName: 'Limit50', width: 70, cellFilter: 'number:2', cellClass: 'text-right' },
            { field: 'Limit51', displayName: 'Limit51', width: 70, cellFilter: 'number:2', cellClass: 'text-right' },
            { field: 'Discount', displayName: 'Disc %', width: 55, cellFilter: 'number:2', cellClass: 'text-right' },
            { field: 'Minimum', displayName: 'Minimum', width: 70, cellFilter: 'number:0', cellClass: 'text-right' },
            { field: 'Internalrate', displayName: 'COGS', width: 80, cellFilter: 'number:0', cellClass: 'text-right' }
        ],
        onRegisterApi: function(gridApi) {
            $scope.gridApi = gridApi;
            if (gridApi.selection) {
                gridApi.selection.on.rowSelectionChanged($scope, function(row) {
                    if (row.isSelected) {
                        $scope.selectGridRow(row.entity);
                    }
                });
            }
        }
    };

    /**
     * Load all lookup data on init
     */
    $scope.loadLookupData = function() {
        var lookupTypes = [
            { type: 'customer', target: 'customerList', label: 'Customer' },
            { type: 'city', target: 'cityList', label: 'City' },
            { type: 'uom', target: 'uomList', label: 'UOM' },
            { type: 'service', target: 'serviceList', label: 'Service' },
            { type: 'modtrans', target: 'modTransList', label: 'Mod Trans' },
            { type: 'pricecode', target: 'priceCodeList', label: 'Price Code' }
        ];

        lookupTypes.forEach(function(lookup) {
            urlServices.ambilData('api/customer-price/lookup', { type: lookup.type }, function(e, d) {
                if (e) {
                    toaster.pop('error', 'Error', 'Failed to load ' + lookup.label + ' data: ' + (e.err || 'Network error'));
                    $scope[lookup.target] = [];
                } else if (d && Array.isArray(d)) {
                    $scope[lookup.target] = d;
                } else {
                    toaster.pop('warning', 'Warning', 'No ' + lookup.label + ' data available');
                    $scope[lookup.target] = [];
                }
            });
        });

        // Load default city for user
        $scope.loadDefaultCity();
    };

    /**
     * Load default city from user's branch - matches VB6 DefaultCity function
     */
    $scope.loadDefaultCity = function() {
        urlServices.ambilData('api/customer-price/default-city', {}, function(e, d) {
            if (!e && d && d.dt && d.dt.cityCode) {
                $scope.data.OriginCode = d.dt.cityCode;
            }
        });
    };

    /**
     * Load pricing grid by customer code (supports both dropdown selection and search input)
     */
    $scope.loadCustomerPrice = function() {
        // Tangkap PriceCode dari dropdown atau dari input search panel Find & Search
        var priceCode = $scope.data.PriceCode || $scope.filterPriceCode || '';
        if (!priceCode) {
            $scope.gridOptions.data = [];
            return;
        }

        var params = {
            PriceCode: priceCode,
            Destination: $scope.filterDestination
        };

        urlServices.ambilData('api/customer-price', params, function(e, d) {
            if (e) {
                toaster.pop('error', 'Error', e.err || 'Failed to load pricing data');
                $scope.gridOptions.data = [];
            } else if (d && Array.isArray(d)) {
                $scope.gridOptions.data = d;
            } else {
                $scope.gridOptions.data = [];
            }
        });
    };

    /**
     * Customer code change handler - matches VB6 Query_Cust function
     */
    $scope.onCustomerChange = function() {
        if ($scope.data.PriceCode) {
            // Find customer name
            var customer = $scope.customerList.find(function(c) {
                return c.code === $scope.data.PriceCode;
            });
            $scope.customerName = customer ? customer.name : '';

            // Load pricing grid
            $scope.loadCustomerPrice();

            // Load consign sites for this customer
            $scope.loadConsignSites();

            // Query customer for DiscountRate and PublishCode - matches VB6 Query_Cust
            urlServices.ambilData('api/customer-price/query-customer', { PriceCode: $scope.data.PriceCode }, function(e, d) {
                if (!e && d && d.dt) {
                    $scope.data.Discount = d.dt.discountRate || 0;
                    if (d.dt.publishCode) {
                        $scope.generateData.BasePriceCode = d.dt.publishCode;
                    }
                }
            });
        } else {
            $scope.customerName = '';
            $scope.gridOptions.data = [];
            $scope.consignSiteList = [];
        }
    };

    /**
     * Load consign sites for current customer - matches VB6 Site function
     */
    $scope.loadConsignSites = function() {
        if (!$scope.data.PriceCode) {
            $scope.consignSiteList = [];
            return;
        }

        urlServices.ambilData('api/customer-price/lookup', {
            type: 'consignsite',
            customerCode: $scope.data.PriceCode
        }, function(e, d) {
            if (!e && d && Array.isArray(d)) {
                $scope.consignSiteList = d;
            } else {
                $scope.consignSiteList = [];
            }
        });
    };

    /**
     * Apply filter to grid
     */
    $scope.applyFilter = function() {
        $scope.loadCustomerPrice();
    };

    /**
     * Refresh grid
     */
    $scope.refreshGrid = function() {
        $scope.loadCustomerPrice();
    };

    /**
     * Select grid row and populate form - matches VB6 GRID_Click
     */
    $scope.selectGridRow = function(row) {
        $scope.selectedNomor = row.Nomor;

        // Populate form with data
        $scope.data = {
            Nomor: row.Nomor,
            PriceCode: row.PriceCode,
            OriginCode: row.OriginCode,
            DestinationCode: row.DestinationCode,
            UOM: row.UOM,
            Service: row.Service,
            ModTrans: row.ModTrans,
            Limit: parseFloat(row.Limit || 0),
            Limit0: parseFloat(row.Limit0 || 0),
            Limit10: parseFloat(row.Limit10 || 0),
            Limit11: parseFloat(row.Limit11 || 0),
            Limit20: parseFloat(row.Limit20 || 0),
            Limit21: parseFloat(row.Limit21 || 0),
            Limit30: parseFloat(row.Limit30 || 0),
            Limit31: parseFloat(row.Limit31 || 0),
            Limit40: parseFloat(row.Limit40 || 0),
            Limit41: parseFloat(row.Limit41 || 0),
            Limit50: parseFloat(row.Limit50 || 0),
            Limit51: parseFloat(row.Limit51 || 0),
            Price1: parseFloat(row.Price1 || 0),
            Price2: parseFloat(row.Price2 || 0),
            Price3: parseFloat(row.Price3 || 0),
            Price4: parseFloat(row.Price4 || 0),
            Price5: parseFloat(row.Price5 || 0),
            Price6: parseFloat(row.Price6 || 0),
            LeadTime: parseInt(row.LeadTime || 0),
            Internalrate: parseFloat(row.Internalrate || 0),
            Discount: parseFloat(row.Discount || 0),
            DiscountRate: parseFloat(row.DiscountRate || 0),
            Minimum: parseFloat(row.Minimum || 0),
            IsFlat: row.IsFlat ? true : false,
            IsConsign: row.Consign ? true : false,
            Consign: row.Consign || '',
            PublishRate: parseFloat(row.PublishRate || 0),
            PublishCode: row.PublishCode || '',
            Note: row.Note || ''
        };
    };

    /**
     * Validate weight limits progression - matches VB6 validation (all 12 limits)
     * VB6 validates: Limit < Limit0 < Limit10 < Limit11 < Limit20 < Limit21 < Limit30 < Limit31 < Limit40 < Limit41 < Limit50 < Limit51
     */
    $scope.validateWeightLimits = function() {
        var limits = [
            { name: 'Limit', value: parseFloat($scope.data.Limit || 0) },
            { name: 'Limit0', value: parseFloat($scope.data.Limit0 || 0) },
            { name: 'Limit10', value: parseFloat($scope.data.Limit10 || 0) },
            { name: 'Limit11', value: parseFloat($scope.data.Limit11 || 0) },
            { name: 'Limit20', value: parseFloat($scope.data.Limit20 || 0) },
            { name: 'Limit21', value: parseFloat($scope.data.Limit21 || 0) },
            { name: 'Limit30', value: parseFloat($scope.data.Limit30 || 0) },
            { name: 'Limit31', value: parseFloat($scope.data.Limit31 || 0) },
            { name: 'Limit40', value: parseFloat($scope.data.Limit40 || 0) },
            { name: 'Limit41', value: parseFloat($scope.data.Limit41 || 0) },
            { name: 'Limit50', value: parseFloat($scope.data.Limit50 || 0) },
            { name: 'Limit51', value: parseFloat($scope.data.Limit51 || 0) }
        ];

        for (var i = 1; i < limits.length; i++) {
            if (limits[i].value > 0 && limits[i].value <= limits[i-1].value) {
                toaster.pop('error', 'Validation Error',
                    'Weight Limit ' + limits[i].name + ' must be greater than ' + limits[i-1].name);
                return false;
            }
        }

        return true;
    };

    /**
     * Validate all required fields - matches VB6 CmdSimpan_Click validation
     */
    $scope.validateForm = function() {
        if (!$scope.data.PriceCode) {
            toaster.pop('error', 'Validation Error', 'Price Code cannot be empty');
            return false;
        }
        if (!$scope.data.OriginCode) {
            toaster.pop('error', 'Validation Error', 'Origin City must be selected');
            return false;
        }
        if (!$scope.data.DestinationCode) {
            toaster.pop('error', 'Validation Error', 'Destination City must be selected');
            return false;
        }
        if (!$scope.data.UOM) {
            toaster.pop('error', 'Validation Error', 'Unit of Measurement must be selected');
            return false;
        }
        if (!$scope.data.Service) {
            toaster.pop('error', 'Validation Error', 'Service Type must be selected');
            return false;
        }
        if (!$scope.data.ModTrans) {
            toaster.pop('error', 'Validation Error', 'Mod Trans must be selected');
            return false;
        }
        if (parseFloat($scope.data.Limit || 0) <= 0) {
            toaster.pop('error', 'Validation Error', 'Weight Limit must be filled');
            return false;
        }
        if (parseFloat($scope.data.Limit0 || 0) <= 0) {
            toaster.pop('error', 'Validation Error', 'Weight Limit0 must be filled');
            return false;
        }
        if (parseFloat($scope.data.Limit10 || 0) <= 0) {
            toaster.pop('error', 'Validation Error', 'Weight Limit10 must be filled');
            return false;
        }
        if (parseFloat($scope.data.Limit11 || 0) <= 0) {
            toaster.pop('error', 'Validation Error', 'Weight Limit11 must be filled');
            return false;
        }
        if (parseFloat($scope.data.Limit20 || 0) <= 0) {
            toaster.pop('error', 'Validation Error', 'Weight Limit20 must be filled');
            return false;
        }
        if (parseFloat($scope.data.Limit21 || 0) <= 0) {
            toaster.pop('error', 'Validation Error', 'Weight Limit21 must be filled');
            return false;
        }
        if (parseFloat($scope.data.Price1 || 0) <= 0) {
            toaster.pop('error', 'Validation Error', 'Price1 must be greater than 0');
            return false;
        }
        if (parseFloat($scope.data.Price2 || 0) <= 0) {
            toaster.pop('error', 'Validation Error', 'Price2 must be filled');
            return false;
        }
        if (parseFloat($scope.data.Price3 || 0) <= 0) {
            toaster.pop('error', 'Validation Error', 'Price3 must be filled');
            return false;
        }
        if (parseFloat($scope.data.Price4 || 0) <= 0) {
            toaster.pop('error', 'Validation Error', 'Price4 must be filled');
            return false;
        }
        if (parseFloat($scope.data.Price5 || 0) <= 0) {
            toaster.pop('error', 'Validation Error', 'Price5 must be filled');
            return false;
        }
        if (parseFloat($scope.data.Price6 || 0) <= 0) {
            toaster.pop('error', 'Validation Error', 'Price6 must be filled');
            return false;
        }
        if (parseInt($scope.data.LeadTime || 0) <= 0) {
            toaster.pop('error', 'Validation Error', 'Lead Time must be filled');
            return false;
        }
        if (parseFloat($scope.data.Internalrate || 0) <= 0) {
            toaster.pop('error', 'Validation Error', 'Internal Rate must be filled');
            return false;
        }
        if ($scope.data.Discount === undefined || $scope.data.Discount === null || $scope.data.Discount === '') {
            toaster.pop('error', 'Validation Error', 'Discount must be filled');
            return false;
        }

        // Validate weight progression
        if (!$scope.validateWeightLimits()) {
            return false;
        }

        return true;
    };

    /**
     * Save or update price - matches VB6 CmdSimpan_Click
     */
    $scope.savePrice = function() {
        if ($scope.isSaving) {
            return;
        }

        // Validate all fields
        if (!$scope.validateForm()) {
            return;
        }

        var confirmMessage = $scope.data.Nomor ?
            'Update this pricing record?' :
            'Save new pricing record?';

        modalService.showModal({}, {
            closeButtonText: 'No',
            actionButtonText: 'Yes',
            headerText: 'Confirm',
            bodyText: confirmMessage
        }).then(function(result) {
            if (result) {
                $scope.isSaving = true;

                var saveMethod = $scope.data.Nomor ? 'updateData' : 'simpanData';

                urlServices[saveMethod]('api/customer-price', $scope.data, function(e, d) {
                    $scope.isSaving = false;

                    if (e) {
                        toaster.pop('error', 'Error', e.err || 'Failed to save pricing');
                    } else {
                        toaster.pop('success', 'Success', d.dt.message || 'Pricing saved successfully');
                        $scope.loadCustomerPrice();
                        if (!$scope.data.Nomor) {
                            $scope.clearForm();
                        }
                    }
                });
            }
        });
    };

    /**
     * Delete price - matches VB6 CmdHapus_Click
     */
    $scope.deletePrice = function() {
        if (!$scope.selectedNomor) {
            toaster.pop('warning', 'Warning', 'Please select a pricing record to delete');
            return;
        }

        modalService.showModal({}, {
            closeButtonText: 'No',
            actionButtonText: 'Yes',
            headerText: 'Confirm Delete',
            bodyText: 'This Price Will Be Deleted, Are You Sure?'
        }).then(function(result) {
            if (result) {
                urlServices.hapusData('api/customer-price', { Nomor: $scope.selectedNomor }, function(e, d) {
                    if (e) {
                        toaster.pop('error', 'Error', e.err || 'Failed to delete pricing');
                    } else {
                        toaster.pop('success', 'Success', 'Price Deleted Success');
                        $scope.clearForm();
                        $scope.loadCustomerPrice();
                    }
                });
            }
        });
    };

    /**
     * Generate pricing from base price with discount - matches VB6 cmdGenerate_Click
     * Includes password protection (KataRahasia)
     */
    $scope.generatePricing = function() {
        if ($scope.isGenerating) {
            return;
        }

        if (!$scope.data.PriceCode) {
            toaster.pop('error', 'Validation Error', 'Please Select Customer Code First');
            return;
        }

        if (!$scope.generateData.BasePriceCode) {
            toaster.pop('error', 'Validation Error', 'Please select Base Price Code');
            return;
        }

        // Password protection - matches VB6 KataRahasia logic
        modalService.showModal({}, {
            closeButtonText: 'Cancel',
            actionButtonText: 'OK',
            headerText: 'Enter Password',
            bodyText: '<input type="password" class="form-control" id="generatePassword" placeholder="Enter Password">'
        }).then(function(result) {
            if (result) {
                var password = document.getElementById('generatePassword').value;

                // Validate password with backend
                urlServices.simpanData('api/customer-price/validate-password', { password: password }, function(e, d) {
                    if (e) {
                        toaster.pop('error', 'Authorization Error', e.err || 'You are not authorized to access this module');
                        return;
                    }

                    // Password valid, proceed with generation
                    var confirmMessage = 'Price Will be Generated, Are You Sure?';

                    modalService.showModal({}, {
                        closeButtonText: 'No',
                        actionButtonText: 'Yes',
                        headerText: 'Confirm Generate Pricing',
                        bodyText: confirmMessage
                    }).then(function(result) {
                        if (result) {
                            $scope.isGenerating = true;

                            var generatePayload = {
                                PriceCode: $scope.data.PriceCode,
                                BasePriceCode: $scope.generateData.BasePriceCode,
                                DiscountPercent: parseFloat($scope.generateData.DiscountPercent || 0)
                            };

                            urlServices.simpanData('api/customer-price/generate', generatePayload, function(e, d) {
                                $scope.isGenerating = false;

                                if (e) {
                                    var errorMsg = e.err || 'Failed to generate pricing';
                                    if (e.err && e.err.includes('No base pricing')) {
                                        errorMsg = 'Base price code "' + $scope.generateData.BasePriceCode + '" has no pricing records';
                                    }
                                    toaster.pop('error', 'Error', errorMsg);
                                } else {
                                    var message = d.dt.message || 'Generate Success';
                                    var details = [];

                                    if (d.dt.existingCount > 0) {
                                        details.push(d.dt.existingCount + ' existing records deleted');
                                    }
                                    if (d.dt.insertedCount) {
                                        details.push(d.dt.insertedCount + ' new records created');
                                    }

                                    if (details.length > 0) {
                                        message += ' (' + details.join(', ') + ')';
                                    }

                                    toaster.pop('success', 'Success', message);
                                    $scope.loadCustomerPrice();
                                    $scope.generateData = {
                                        BasePriceCode: '',
                                        DiscountPercent: 0
                                    };
                                }
                            });
                        }
                    });
                });
            }
        });
    };

    /**
     * Check Price - updates IsPrice flag for price codes with >5 records
     * Matches VB6 CekHargaUpdate and Binding_cekHarga
     */
    $scope.checkPrice = function() {
        urlServices.simpanData('api/customer-price/check-price', {}, function(e, d) {
            if (e) {
                toaster.pop('error', 'Error', e.err || 'Failed to check price');
            } else {
                toaster.pop('success', 'Success', 'Price check completed');
                $scope.showCheckPrice = true;
                // Load price codes with IsPrice=1
                if (d && d.dt && Array.isArray(d.dt)) {
                    $scope.gridOptions.data = d.dt;
                }
            }
        });
    };

    /**
     * Toggle between normal view and check price view
     */
    $scope.toggleCheckPriceView = function() {
        $scope.showCheckPrice = !$scope.showCheckPrice;
        if (!$scope.showCheckPrice) {
            // Return to normal view
            $scope.loadCustomerPrice();
        }
    };

    // clearForm moved to line 550 with keepCustomer support

    /**
     * Show customer lookup modal
     */
    $scope.showCustomerLookup = function() {
        modalFactory.open('lg', 'modal.list.html', 'modalListCtrl', {
            functionName: 'customerList',
            params: {}
        });
    };

    /**
     * Listen for customer selection from modal
     */
    $scope.$on('pilih-contact', function(event, data) {
        if (data && data.CustomerCode) {
            $scope.data.PriceCode = data.CustomerCode;
            $scope.onCustomerChange();
        }
    });

    /**
     * Show City Code Setting modal for Origin or Destination
     * Opens a CRUD modal for managing city codes (matches VB6 DIST_MDKota form)
     */
    $scope.showCityLookup = function(forField) {
        $scope.cityLookupFor = forField; // 'origin' or 'destination'
        var modalInstance = modalFactory.open('lg', 'modal.city.setting.html', 'modalCitySettingCtrl', {
            forField: forField
        });
        
        // After modal closes, refresh the city list
        modalInstance.result.then(function(selectedCity) {
            // If a city was selected, set it to the appropriate field
            if (selectedCity && selectedCity.CityCode) {
                if ($scope.cityLookupFor === 'destination') {
                    $scope.data.DestinationCode = selectedCity.CityCode;
                } else {
                    $scope.data.OriginCode = selectedCity.CityCode;
                }
            }
            // Refresh city list to reflect any changes made in the modal
            $scope.loadCityList();
        }, function() {
            // Modal dismissed - still refresh city list in case changes were made
            $scope.loadCityList();
        });
    };

    /**
     * Load city list for dropdowns
     */
    $scope.loadCityList = function() {
        urlServices.ambilData('api/customer-price/cities', {}, function(err, result) {
            if (err) {
                toaster.pop('error', 'Error', 'Failed to load cities');
                return;
            }
            $scope.cityList = (result && result.dt) ? result.dt.map(function(city) {
                return {
                    code: city.CityCode,
                    name: city.CityName
                };
            }) : [];
        });
    };

    /**
     * Listen for city selection from modal (legacy support)
     */
    $scope.$on('pilih-kota', function(event, data) {
        if (data && data.city) {
            if ($scope.cityLookupFor === 'destination') {
                $scope.data.DestinationCode = data.city.CityCode;
            } else {
                $scope.data.OriginCode = data.city.CityCode;
            }
        }
    });

    /**
     * Show consign site lookup modal - matches VB6 Site function
     */
    $scope.showConsignSiteLookup = function() {
        if (!$scope.data.PriceCode) {
            toaster.pop('warning', 'Warning', 'Please select customer first');
            return;
        }

        if ($scope.consignSiteList && $scope.consignSiteList.length > 0) {
            modalFactory.open('lg', 'modal.list.html', 'modalListCtrl', {
                functionName: 'consignSiteList',
                params: { customerCode: $scope.data.PriceCode },
                data: $scope.consignSiteList
            });
        } else {
            toaster.pop('info', 'Info', 'No consign sites found for this customer');
        }
    };

    /**
     * Listen for consign site selection from modal
     */
    $scope.$on('pilih-consign-site', function(event, data) {
        if (data && data.code) {
            $scope.data.Consign = data.code;
            $scope.data.IsConsign = true;
            toaster.pop('success', 'Success', 'Consign site selected: ' + data.name);
        }
    });

    /**
     * Calculate COGS (HPP) - sesuai SC desktop cmdCogs_Click
     */
    $scope.calculateCOGS = function() {
        if (!$scope.data.OriginCode || !$scope.data.DestinationCode ||
            !$scope.data.Service || !$scope.data.ModTrans || !$scope.data.UOM) {
            toaster.pop('warning', 'Warning', 'Please fill Origin, Destination, Service, ModTrans, and UOM first');
            return;
        }

        // Call API to calculate COGS
        var params = {
            OriginCode: $scope.data.OriginCode,
            DestinationCode: $scope.data.DestinationCode,
            Service: $scope.data.Service,
            ModTrans: $scope.data.ModTrans,
            UOM: $scope.data.UOM
        };

        urlServices.ambilData('api/customer-price/calculate-cogs', params, function(e, d) {
            if (e) {
                toaster.pop('error', 'Error', 'Failed to calculate COGS: ' + (e.err || 'Unknown error'));
            } else if (d && d.dt && d.dt.cogs) {
                $scope.data.Internalrate = d.dt.cogs;
                toaster.pop('success', 'Success', 'COGS calculated: ' + d.dt.cogs);
            } else {
                toaster.pop('warning', 'Warning', 'COGS data not found for this route');
                $scope.data.Internalrate = 0;
            }
        });
    };

    /**
     * Print pricing report - sesuai SC desktop cmdPrint_Click
     */
    $scope.printPrice = function() {
        var priceCode = $scope.data.PriceCode || $scope.filterPriceCode;
        if (!priceCode) {
            toaster.pop('warning', 'Warning', 'Please select or search a customer first');
            return;
        }

        urlServices.ambilData('api/customer-price/print', { PriceCode: priceCode }, function(e, d) {
            if (e) {
                toaster.pop('error', 'Error', 'Failed to load print data: ' + (e.err || 'Unknown error'));
            } else if (d && d.dt && d.dt.data) {
                var printWindow = window.open('', '_blank');
                if (!printWindow) {
                    toaster.pop('error', 'Error', 'Please allow popup windows for printing');
                    return;
                }

                var rows = d.dt.data;
                var tableRows = '';
                rows.forEach(function(row) {
                    tableRows += '<tr>' +
                        '<td>' + (row.OriginCode || '') + '</td>' +
                        '<td>' + (row.OriginName || '') + '</td>' +
                        '<td>' + (row.DestinationCode || '') + '</td>' +
                        '<td>' + (row.DestinationName || '') + '</td>' +
                        '<td>' + (row.UOM || '') + '</td>' +
                        '<td>' + (row.Service || '') + '</td>' +
                        '<td>' + (row.ModTrans || '') + '</td>' +
                        '<td align="right">' + formatNumber(row.Price1 || 0, 0) + '</td>' +
                        '<td align="right">' + formatNumber(row.Price2 || 0, 0) + '</td>' +
                        '<td align="right">' + formatNumber(row.LeadTime || 0, 0) + '</td>' +
                        '<td align="right">' + formatNumber(row.Limit || 0, 2) + '</td>' +
                        '</tr>';
                });

                printWindow.document.write('<!DOCTYPE html><html><head>' +
                    '<title>Customer Price Report - ' + d.dt.priceCode + '</title>' +
                    '<style>' +
                    'body { font-family: Arial, sans-serif; font-size: 12px; margin: 20px; }' +
                    'h2 { margin-bottom: 5px; }' +
                    'p { margin: 3px 0; }' +
                    'table { border-collapse: collapse; width: 100%; margin-top: 15px; }' +
                    'th, td { border: 1px solid #333; padding: 6px 8px; }' +
                    'th { background-color: #4CAF50; color: white; }' +
                    'tr:nth-child(even) { background-color: #f2f2f2; }' +
                    '</style></head><body>' +
                    '<h2>Customer Price Report</h2>' +
                    '<p><strong>Customer Code:</strong> ' + d.dt.priceCode + '</p>' +
                    '<p><strong>Customer Name:</strong> ' + (d.dt.customerName || '') + '</p>' +
                    '<p><strong>Print Date:</strong> ' + new Date(d.dt.printDate).toLocaleString('id-ID') + '</p>' +
                    '<table><thead><tr>' +
                    '<th>Origin</th><th>Origin Name</th><th>Dest</th><th>Dest Name</th>' +
                    '<th>UOM</th><th>Service</th><th>ModTrans</th>' +
                    '<th>Price1</th><th>Price2</th><th>Lead Time</th><th>Limit</th>' +
                    '</tr></thead><tbody>' + tableRows + '</tbody></table></body></html>');
                printWindow.document.close();
                printWindow.print();
            } else {
                toaster.pop('warning', 'Warning', 'No pricing data found for this customer');
            }
        });
    };

    /**
     * Format number helper
     */
    var formatNumber = function(num, decimals) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    /**
     * Export to Excel - sesuai SC desktop cmdExport_Click
     */
    $scope.exportPrice = function() {
        var priceCode = $scope.data.PriceCode || $scope.filterPriceCode;
        if (!priceCode) {
            toaster.pop('warning', 'Warning', 'Please select or search a customer first');
            return;
        }

        var exportUrl = '/api/customer-price/export?PriceCode=' + encodeURIComponent(priceCode);
        window.location.href = exportUrl;
        toaster.pop('success', 'Success', 'Exporting to Excel...');
    };

    /**
     * Print Discount Per Customer - sesuai button di desktop
     */
    $scope.printDiscountPerCustomer = function() {
        var priceCode = $scope.data.PriceCode || $scope.filterPriceCode;
        if (!priceCode) {
            toaster.pop('warning', 'Warning', 'Please select or search a customer first');
            return;
        }

        urlServices.ambilData('api/customer-price/print-discount', { PriceCode: priceCode }, function(e, d) {
            if (e) {
                toaster.pop('error', 'Error', 'Failed to load discount report: ' + (e.err || 'Unknown error'));
            } else if (d && d.dt && d.dt.data) {
                var printWindow = window.open('', '_blank');
                if (!printWindow) {
                    toaster.pop('error', 'Error', 'Please allow popup windows for printing');
                    return;
                }

                var rows = d.dt.data;
                var tableRows = '';
                rows.forEach(function(row) {
                    var discClass = row.calculatedDiscount > 0 ? 'color:#e74c3c;font-weight:bold;' : '';
                    tableRows += '<tr>' +
                        '<td>' + (row.origin || '') + '</td>' +
                        '<td>' + (row.destination || '') + '</td>' +
                        '<td>' + (row.uom || '') + '</td>' +
                        '<td>' + (row.service || '') + '</td>' +
                        '<td>' + (row.modTrans || '') + '</td>' +
                        '<td align="right">' + formatNumber(row.publishRate || 0, 0) + '</td>' +
                        '<td align="right">' + formatNumber(row.price1 || 0, 0) + '</td>' +
                        '<td align="right" style="' + discClass + '">' + (row.calculatedDiscount || 0) + '%</td>' +
                        '</tr>';
                });

                printWindow.document.write('<!DOCTYPE html><html><head>' +
                    '<title>Discount Report - ' + d.dt.priceCode + '</title>' +
                    '<style>' +
                    'body { font-family: Arial, sans-serif; font-size: 12px; margin: 20px; }' +
                    'h2 { margin-bottom: 5px; }' +
                    'p { margin: 3px 0; }' +
                    'table { border-collapse: collapse; width: 100%; margin-top: 15px; }' +
                    'th, td { border: 1px solid #333; padding: 6px 8px; }' +
                    'th { background-color: #2980b9; color: white; }' +
                    'tr:nth-child(even) { background-color: #f2f2f2; }' +
                    '</style></head><body>' +
                    '<h2>Discount Report Per Customer</h2>' +
                    '<p><strong>Customer Code:</strong> ' + d.dt.priceCode + '</p>' +
                    '<p><strong>Print Date:</strong> ' + new Date(d.dt.printDate).toLocaleString('id-ID') + '</p>' +
                    '<table><thead><tr>' +
                    '<th>Origin</th><th>Destination</th><th>UOM</th><th>Service</th><th>ModTrans</th>' +
                    '<th>Publish Rate</th><th>Price1</th><th>Discount %</th>' +
                    '</tr></thead><tbody>' + tableRows + '</tbody></table></body></html>');
                printWindow.document.close();
                printWindow.print();
            } else {
                toaster.pop('warning', 'Warning', 'No discount data found for this customer');
            }
        });
    };

    /**
     * Clear form - dengan Keep Customer option - matches VB6 Clear function
     */
    $scope.clearForm = function() {
        var priceCode = $scope.keepCustomer ? $scope.data.PriceCode : ''; // Keep customer if checkbox checked

        $scope.data = {
            PriceCode: priceCode,
            IsFlat: false,
            IsConsign: false,
            Limit: 0,
            Limit0: 0,
            Limit10: 0,
            Limit11: 0,
            Limit20: 0,
            Limit21: 0,
            Limit30: 0,
            Limit31: 0,
            Limit40: 0,
            Limit41: 0,
            Limit50: 0,
            Limit51: 0,
            Price1: 0,
            Price2: 0,
            Price3: 0,
            Price4: 0,
            Price5: 0,
            Price6: 0,
            LeadTime: 0,
            Internalrate: 0,
            Discount: 0,
            DiscountRate: 0,
            Minimum: 0,
            PublishRate: 0,
            PublishCode: ''
        };

        $scope.selectedNomor = null;

        if ($scope.gridApi) {
            $scope.gridApi.selection.clearSelectedRows();
        }

        // Reload customer name if keeping customer
        if (priceCode) {
            $scope.onCustomerChange();
        }
    };

    // Initialize on load
    $scope.loadLookupData();

}]);
